import produce from 'immer'
import { PrecedentsAdmin, TiledMenu } from 'interfaces/precedents'
import { Reducer } from 'redux'

import {
  SET_PRECEDENTS_CONTENT_ENTER_IF_EMPTY,
  SET_PRECEDENTS_EXPANDED_SECTION,
  SET_PRECEDENT_ADMIN_IS_UPDATE_MODE,
  SET_PRECEDENT_ADMIN_PARENTS,
  SET_PRECEDENTS_VIEW,
  SET_PRECEDENT_ID,
  SET_PRECEDENT_SECTION_ID,
  SET_PRECEDENT_ADMIN_FILES,
  SET_PRECEDENT_ADMIN_FILE_NAME,
  SET_PRECEDENT_ADMIN_FILE_SELECTED,
  SET_PRECEDENT_ADMIN_FILE_DESCRIPTION,
  SET_PRECEDENT_ADMIN_PARENT_ID,
  SET_PRECEDENT_ADMIN_POSITION,
  SET_PRECEDENT_ADMIN_TITLE,
  SET_PRECEDENT_ADMIN_TIERS,
  SET_PRECEDENT_ADMIN_CHECKBOXES,
  SET_PRECEDENT_TILED_MENU,
  SET_PRECEDENT_ADMIN_PLACE_AT
} from 'redux/actions/types'

interface PrecedentsState {
  view: string|null;
  sectionId: string|null;
  precedentId: string|null;
  expandedSection: string|null;
  tiledMenu: TiledMenu;
  admin: PrecedentsAdmin,
  content: {
    enterIfEmpty: boolean;
  }
}

const initialState:PrecedentsState = {
  view: null,
  sectionId: null,
  precedentId: null,
  expandedSection: null,
  tiledMenu: null,
  admin: {
    isUpdateMode: null,
    files: null,
    fileSelected: null,
    fileName: null,
    title: '',
    description: '',
    parents: null,
    parentId: null,
    position: '',
    tiers: [],
    checkBoxes: [
      { value: 'lite', checked: false, label: 'FC Core' },
      { value: 'premium', checked: false, label: 'FC Premium' },
      { value: 'clarilis', checked: false, label: 'Clarilis M&A' },
      { value: 'clarilis-shares', checked: false, label: 'Clarilis Shares' }
    ],
    placeAt: null
  },
  content: {
    enterIfEmpty: false
  }
}
const precedents:Reducer<PrecedentsState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRECEDENTS_CONTENT_ENTER_IF_EMPTY:
      return produce(state, draft => {
        draft.content.enterIfEmpty = action.enterIfEmpty
      })
    case SET_PRECEDENTS_VIEW:
      return produce(state, draft => {
        draft.view = action.view
      })
    case SET_PRECEDENT_SECTION_ID:
      return produce(state, draft => {
        draft.sectionId = action.sectionId
      })
    case SET_PRECEDENT_ID:
      return produce(state, draft => {
        draft.precedentId = action.precedentId
      })
    case SET_PRECEDENTS_EXPANDED_SECTION:
      return produce(state, draft => {
        draft.expandedSection = action.expandedSection
      })
    case SET_PRECEDENT_ADMIN_IS_UPDATE_MODE:
      return produce(state, draft => {
        draft.admin.isUpdateMode = action.isUpdateMode
      })
    case SET_PRECEDENT_ADMIN_FILES:
      return produce(state, draft => {
        draft.admin.files = action.files
      })
    case SET_PRECEDENT_ADMIN_FILE_SELECTED:
      return produce(state, draft => {
        draft.admin.fileSelected = action.fileSelected
      })
    case SET_PRECEDENT_ADMIN_FILE_NAME:
      return produce(state, draft => {
        draft.admin.fileName = action.fileName
      })
    case SET_PRECEDENT_ADMIN_FILE_DESCRIPTION:
      return produce(state, draft => {
        draft.admin.description = action.description
      })
    case SET_PRECEDENT_ADMIN_TITLE:
      return produce(state, draft => {
        draft.admin.title = action.title
      })
    case SET_PRECEDENT_ADMIN_PARENTS:
      return produce(state, draft => {
        draft.admin.parents = action.parents
      })
    case SET_PRECEDENT_ADMIN_PARENT_ID:
      return produce(state, draft => {
        draft.admin.parentId = action.parentId
      })
    case SET_PRECEDENT_ADMIN_POSITION:
      return produce(state, draft => {
        draft.admin.position = action.position
      })
    case SET_PRECEDENT_ADMIN_TIERS:
      return produce(state, draft => {
        draft.admin.tiers = action.tiers
      })
    case SET_PRECEDENT_ADMIN_CHECKBOXES:
      return produce(state, draft => {
        draft.admin.checkBoxes = action.checkBoxes
      })
    case SET_PRECEDENT_TILED_MENU:
      return produce(state, draft => {
        draft.tiledMenu = action.tiledMenu
      })
    case SET_PRECEDENT_ADMIN_PLACE_AT:
      return produce(state, draft => {
        draft.admin.placeAt = action.placeAt
      })
    default:
      return state
  }
}

export default precedents
